import { pickBy } from "lodash-es";
export var decodeURLParams = function (search) {
    if (search.indexOf("?") <= -1)
        return {};
    var hashes = search.slice(search.indexOf("?") + 1).split("&");
    return hashes.reduce(function (params, hash) {
        var _a, _b;
        var split = hash.indexOf("=");
        if (split < 0) {
            return Object.assign(params, (_a = {},
                _a[hash] = null,
                _a));
        }
        var key = hash.slice(0, split);
        var val = hash.slice(split + 1);
        return Object.assign(params, (_b = {}, _b[key] = decodeURIComponent(val), _b));
    }, {});
};
// obj => a=b&c=d;
export var objectToUrlQuery = function (obj) {
    var fn = function (all, prop) {
        return "" + (all.length ? all + "&" : all) + prop + "=" + obj[prop];
    };
    return "" + Object.keys(obj).reduce(fn, "");
};
export var getUrlParams = function () {
    return decodeURLParams(location.hash);
};
export function parseURL(url) {
    var a = document.createElement("a");
    a.href = url;
    return {
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function () {
            // tslint:disable-next-line: one-variable-per-declaration
            var ret = {}, seg = a.search.replace(/^\?/, "").split("&"), len = seg.length;
            // tslint:disable-next-line: one-variable-per-declaration
            var i = 0, s;
            for (; i < len; i += 1) {
                if (!seg[i]) {
                    continue;
                }
                s = seg[i].split("=");
                ret[s[0]] = s[1];
            }
            return ret;
        })(),
        hash: a.hash.replace("#", "")
    };
}
export function currentPageHashToReturnUrl() {
    var hash = "" + location.hash.slice(2);
    var pathnameRaw = hash.match(/([^?]*)/)[1];
    var params = parseURL(hash).params;
    params["returnUrl"] = pathnameRaw;
    var url = Object.keys(params).length ? "?" + objectToUrlQuery(params) : "";
    return url;
}
export function loginPageHashToRedirectUrl() {
    var params = decodeURLParams(window.location.href);
    if (params.returnUrl && params.returnUrl.startsWith("account")) {
        delete params.returnUrl;
    }
    var filterParams = pickBy(params, function (value, key) {
        return !!value && key !== "returnUrl";
    });
    var otherQuery = objectToUrlQuery(filterParams);
    otherQuery = otherQuery.length ? "?" + otherQuery : "";
    var url = params.returnUrl ? "" + params.returnUrl + otherQuery : otherQuery;
    return url;
}
